import { createSelector } from 'reselect';
import { type RootState } from '@/state';

export const demo = ({ demo: { demo } }: RootState) => demo;

export const demoTitleLength = createSelector(
  demo,
  (demo) => demo?.title?.length ?? 0,
);
